import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-request-status-dialog",
  templateUrl: "./request-status-dialog.component.html",
  styleUrls: ["./request-status-dialog.component.scss"]
})
export class RequestStatusDialogComponent implements OnInit {
  header: string;
  description: string;

  constructor(
    public translate: TranslateService,
    private dialogRef: MatDialogRef<RequestStatusDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: RequestStatusData
  ) {}

  ngOnInit(): void {
    this.header = `dialog.${this.data.type}_Title`;

    switch (this.data.type) {
      case "Dup_Quote":
        this.description = this.translate
          .instant("dialog.duplicateFound")
          .replace("{1}", this.data.vehicleNo.toUpperCase())
          .replace("{2}", this.data.email);
        break;

      case "Dup_Active_Link":
        this.description = this.translate
          .instant("dialog.duplicateLink")
          .replace("{1}", this.data.vehicleNo.toUpperCase())
          .replace("{2}", this.data.email);
        break;
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

interface RequestStatusData {
  vehicleNo: string;
  email: string;
  type: "Dup_Quote" | "Dup_Active_Link";
}
